<template>
  <page>
    <div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-calendar-range</v-icon>
          <v-toolbar-title>Date Ranges</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6>
                  <cal-picker v-model="reportForm.tranFromDate" :label="labels.tranFromDate" v-validate="fromDateValidation(reportForm.tranToDate)" :data-vv-as="labels.tranFromDate" data-vv-name="tranFromDate" :error-messages="errors.collect('tranFromDate')" :min="fromDateMinDate" :max="fromDateMax()"></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <cal-picker v-model="reportForm.tranToDate" :label="labels.tranToDate" v-validate="toDateValidation(reportForm.tranFromDate)" :data-vv-as="labels.tranToDate" data-vv-name="tranToDate" :error-messages="errors.collect('tranToDate')" :min="reportForm.tranFromData" :max="today"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-filter</v-icon>
          <v-toolbar-title>Filters</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field v-model="reportForm.branch" :label="labels.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="labels.branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" v-validate="'required'" readonly></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="reportForm.fund" :label="labels.fund" :error-messages="errors.collect('fund')" data-vv-name="fund" :data-vv-as="labels.fund" append-icon="mdi-magnify" @click:append="getHelpList('fund')" v-validate="'required'" readonly></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="reportForm.riCo" :label="labels.riCo" :error-messages="errors.collect('riCo')" data-vv-name="riCo" :data-vv-as="labels.riCo" append-icon="mdi-magnify" @click:append="getHelpList('riCo')" readonly></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="reportForm.acctNoSfx" :label="labels.acctNoSfx" :error-messages="errors.collect('acctNoSfx')" data-vv-name="acctNoSfx" :data-vv-as="labels.acctNoSfx" append-icon="mdi-magnify" @click:append="getHelpList('suffix')" readonly></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :items="directRiList" v-model="reportForm.directRi" :label="labels.directRi" item-text="label" item-value="value" data-vv-name="directRi" :data-vv-as="labels.directRi" :error-messages="errors.collect('directRi')" @change="doDisplayTrans"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-settings</v-icon>
          <v-toolbar-title>Report Setting</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-autocomplete :items="typeReportList" v-model="reportForm.reportType" :label="labels.reportType" item-text="label" item-value="value" data-vv-name="reportType" :data-vv-as="labels.reportType" :error-messages="errors.collect('reportType')" @change="doDisplayTrans"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :items="currTypeList" v-model="reportForm.currType" :label="labels.currType" item-text="label" item-value="value" data-vv-name="currType" :data-vv-as="labels.currType" :error-messages="errors.collect('currType')" @change="doDisplayTrans"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="reportForm.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex lg6 xs12>
                <v-checkbox v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
              </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-dialog v-model="helplist" width="900px"   persistent>
          <helplist v-if="helpListActive" :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
        </v-dialog>
      </v-card>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import Helplist from '../Helplist'
import { checkDateRangeFrom, checkDateRangeTo, directRiList, currTypeList } from './index'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        tranFromDate: 'Transaction Date From',
        tranToDate: 'To',
        branch: 'Branch',
        fund: 'Fund',
        riCo: 'RI Company',
        acctNoSfx: 'Suffix',
        directRi: 'Direct / RI Inwards',
        reportType: 'Type of Report',
        currType: 'Type of Currency',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print run-time parameters'
      },
      reportForm: {
        tranFromDate: undefined,
        tranToDate: new Date(),
        branch: 'All',
        fund: 'All',
        riCo: 'All',
        acctNoSfx: 'All',
        directRi: 'D',
        reportType: 'D',
        currType: 'L',
        format: undefined,
        printRptRunTime: false
      },
      // HelpList
      helplist: false,
      apiURI: '',
      mode: '',
      param: '',
      // Other
      directRiList: [],
      currTypeList: [],
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      supportedFormat: [],
      loading: false,
      helpListActive: false
    }
  },
  computed: {
    riMenu() {
      return this.$store.state.reports.riReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    typeReportList() {
      return [
        { label: 'Both', value: 'B' },
        { label: 'Details', value: 'D' },
        { label: 'Summary', value: 'S' }
      ]
    },
    displayTransAE() {
      return this.reportForm.reportType === 'S'
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.riReports.init !== 1) {
          await this.$store.dispatch('riReportsInit')
        }
        const apiURI = this.riMenu.riOutPremReg
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      this.helpListActive = true
      if (fieldName === 'branch') {
        this.apiURI = this.menu.getBranchList
        this.param = this.reportForm.branch
      } else if (fieldName === 'fund') {
        this.apiURI = this.menu.getFundList
        this.param = this.reportForm.fund
      } else if (fieldName === 'riCo') {
        this.apiURI = this.menu.getRiCoList
        this.param = this.reportForm.riCo
      } else {
        this.apiURI = this.menu.getAcctNoSfxList
        this.param = this.reportForm.acctNoSfx
      }
      this.helplist = true
    },
    doClose() {
      this.helplist = false
      this.helpListActive = false
    },
    doAssign(Obj) {
      if (this.mode === 'branch') {
        this.reportForm.branch = ''
        this.reportForm.branch = Obj.finalSelectedItems.toString()
      } else if (this.mode === 'fund') {
        this.reportForm.fund = ''
        this.reportForm.fund = Obj.finalSelectedItems.toString()
      } else if (this.mode === 'riCo') {
        this.reportForm.riCo = ''
        this.reportForm.riCo = Obj.finalSelectedItems.toString()
      } else {
        this.reportForm.acctNoSfx = ''
        this.reportForm.acctNoSfx = Obj.finalSelectedItems.toString()
      }
      this.helpListActive = false
      this.brnHelplist = false
      this.fundHelplist = false
      this.acctNoSfxHelplist = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doDisplayTrans() {
      if (this.reportForm.reportType === 'S') {
        this.reportForm.displayTrans = false
      }
    },
    fromDateMax() {
      if (this.reportForm.toDate1) {
        return this.reportForm.toDate1
      } else {
        return new Date(2070, 11, 31)
      }
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.doInit()
    this.directRiList = directRiList
    this.currTypeList = currTypeList
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  mixins: [
    MessageMixin
  ],
  components: {
    Helplist
  }
}
</script>
